import cx from "classnames";
import { Tooltip } from "components-redesign/Tooltip/Tooltip";
import TooltipContext, {
  TooltipContextProvider,
} from "components-redesign/Tooltip/TooltipContext";
import { FlexContent } from "components/FlexContent/FlexContent";
import { ReactComponent as CurrentUserIcon } from "icons/navbar/currentUserMenu/current-user.svg";
import { ReactComponent as DataseatLogo } from "icons/navbar/dataseat-logo.svg";

import { INavigationMenuItem } from "model/routing";
import React, { useContext } from "react";
import CurrentUserMenu from "./CurrentUserMenu";
import InfoItemsMenu from "./InfoItemsMenu";
import RoutesMenu from "./RoutesMenu";
import { useInfoMenuStyles, useNavMenuStyles } from "./styles";

interface Props {
  menuItems: INavigationMenuItem[];
  rootPath?: string;
}
function NavigationMenu({ menuItems, rootPath }: Props) {
  const { classes } = useNavMenuStyles();
  const { classes: infoMenuClasses } = useInfoMenuStyles();

  const [currentUserMenuAnchorEl, setCurrentUserMenuAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const [isProfileActive, setIsProfileActive] = React.useState(false);

  const onUserMenuOpen = (event: React.MouseEvent<any>) => {
    setCurrentUserMenuAnchorEl(event.currentTarget);
  };
  const onUserMenuClose = () => {
    setCurrentUserMenuAnchorEl(null);
  };

  const { openedTooltipId, handleTooltipTrigger, removeTooltipById } =
    useContext(TooltipContext);
  const profileTooltipId = "profile-settings";

  return (
    <div className={classes.root}>
      <div className={classes.blueOvalBg} />
      <FlexContent
        direction="column"
        align="center"
        justify="space-between"
        className={classes.flexMenusContainer}>
        <FlexContent
          direction="column"
          justify="center"
          align="center"
          gap="26px">
          <DataseatLogo />
          <RoutesMenu
            menuItems={menuItems}
            rootPath={rootPath}
          />
        </FlexContent>
        <FlexContent
          direction="column"
          justify="center"
          align="center"
          gap="0px">
          <InfoItemsMenu rootPath={rootPath} />
          <Tooltip
            title="Profile Settings"
            placement="right"
            disableListeners
            open={openedTooltipId === profileTooltipId}
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 8],
                    },
                  },
                ],
              },
            }}>
            <div
              onMouseEnter={handleTooltipTrigger(profileTooltipId)}
              onMouseLeave={removeTooltipById(profileTooltipId)}
              className={cx(infoMenuClasses.infoItem, {
                [infoMenuClasses.infoItemActive]: isProfileActive,
              })}>
              <FlexContent
                className={infoMenuClasses.infoItemBg}
                justify="center"
                align="center"
                style={{
                  cursor: "pointer",
                }}>
                <CurrentUserIcon
                  style={{
                    width: "32px",
                    height: "32px",
                  }}
                  onClick={onUserMenuOpen}
                />
              </FlexContent>
            </div>
          </Tooltip>
          <CurrentUserMenu
            anchorEl={currentUserMenuAnchorEl}
            open={Boolean(currentUserMenuAnchorEl)}
            onClose={onUserMenuClose}
            onActive={setIsProfileActive}
          />
        </FlexContent>
      </FlexContent>
    </div>
  );
}

function NavigationMenuWithContext(props: Props) {
  return (
    <TooltipContextProvider>
      <NavigationMenu {...props} />
    </TooltipContextProvider>
  );
}

export default NavigationMenuWithContext;
